<template lang="pug">
    div.row.header.admin
        div.container.property
            div.main
                //div.mn__block.mn__hamburger
                    include ../../snippets/menu.pug
                //mn__hamburger

                div.mn__block.mn__logo
                    router-link.link(to="/admin")
                        img.logo(src='@/assets/logo_black.png')
                        span.section ADMIN
                //mn__logo

                div.mn__block.mn__profile
                    div.profile__pic(@click="showDropdown = !showDropdown" :class="{'is-active': showDropdown}")
                        div.imageCover.ratio-1-1(:data-abc="toCharAt(user.name)")
                    div.profile__dropdown(v-if="showDropdown")
                        div.profile
                            div.profile__content
                                div.name {{user.name}}
                                div.email {{user.email}}
                            div.profile__menu
                                a.link(href="/admin/words?page=1") Список слов
                                a.link(href="/admin/new-words?page=1") Модерация слов
                                a.link(href="/admin/users?page=1") Список пользователей
                                a.link(href="/" target="_blank") Открыть сайт
                                a.link.btnLogout(@click="logout()") Выйти
        //container
    //header
</template>

<script>
    export default {
        name: "Header",
        data() {
          return {
              showDropdown: false
          }
        },
        methods: {
            logout() {
                this.$store.dispatch('setToken', null);
                this.$store.dispatch('setUser', null);
            },
            toCharAt(text) {
                return text.charAt(0).toUpperCase()
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
        },
    }
</script>
